import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ISetProjectAction } from '../../../../ts/ServerApi/types/actionNames';
import { moveContents } from '../../../actions/spaces/MoveContentsAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const MoveAction: IEntityAction<IContentInfo, ISetProjectAction> = {
  name: EntityActionNames.Move,
  translateName: Messages.move_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: ISetProjectAction) => !!(availableActions && availableActions.setProject),
  createReduxAction: (targetItems: IContentInfo[]) => moveContents(targetItems)
};
